import React from 'react';

import { formatFigure } from 'Helpers/formatService';

// Prices and quantities render as entered, so the floor sits below any precision they carry.
const formatRaw = (value) => formatFigure(value, String, { precision: 4 });

export default function AssignPackItem({ packItem }) {
    return (
        <tr>
            <td className="tw-break-words">{packItem.name}</td>
            <td>{formatRaw(packItem.price)}</td>
            <td>{formatRaw(packItem.pivot.amount)}</td>
            <td>{formatRaw(packItem.price * packItem.pivot.amount)}</td>
        </tr>
    );
}
